import React from 'react'

import {
  Toolbar,
  withDataProvider,
  showNotification,
  GET_ONE
} from 'react-admin'

import Cookies from 'js-cookie'
import { createStyles, WithStyles } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import { ASSIGN_EXPERT } from '../../../providers/constants'
import UsersSelect from '../../../elements/UsersSelect'
import FormDialog from '../../../elements/FormDialog'
import DeactivateSegmentModal from '../DeactivateSegmentModal'
import ButtonsGroupMethodist from "./ButtonsGroupMethodist";
import ButtonsGroupManagerMo from "./ButtonsGroupManagerMo";
import ButtonsGroupDirectorMo from "./ButtonsGroupDirectorMo";
import ButtonsGroupExpertReviewer from "./ButtonsGroupExpertReviewer";
import ButtonsGroupExpertDeveloper from "./ButtonsGroupExpertDeveloper";
import ButtonsGroupEditor from "./ButtonsGroupEditor";
import ButtonsGroupCensor from "./ButtonsGroupCensor";

// todo рефакторинг


const styles = () => createStyles({
  wrap: {
    display: 'flex',
    width: '700px',
    marginBottom: '20px',
  },
  elements: {
    marginRight: '25px',
  },
  buttonWrap: {
    width: '596px',
    textAlign: 'right',
  },
  textAreaWrap: {
    marginBottom: '15px',
  },
  button: {
    marginRight: '15px'
  },
})

const responseSuccess = {
  onSuccess: {
    notification: { body: 'Сохранено', level: 'info' },
  },
  onFailure: {
    notification: { body: 'Error', level: 'warning' },
  },
  refresh: true
}

interface IProps extends WithStyles {
  dataProvider: any,
  segmentId: number,
  experts: any,
  permissions: any,
  status: any,
  users: any,
  verifyStatus: number,
  module: any
}

const ToolbarProvider = withStyles(styles)(({classes, dataProvider, segmentId, experts, status, users = {}, verifyStatus, module} : IProps) => {
  const role = Cookies.get('role')
  const statusId = status.id

  return (
    <>
      {role === 'admin' && (<ButtonsGroupDirectorMo segmentId={segmentId} statusId={statusId} experts={experts} users={users} verifyStatus={verifyStatus} />)}
      {role === 'managerMo' && (<ButtonsGroupManagerMo segmentId={segmentId} statusId={statusId} experts={experts} users={users} verifyStatus={verifyStatus} />)}
      {role === 'directorMo' && (<ButtonsGroupDirectorMo segmentId={segmentId} statusId={statusId} experts={experts} users={users} verifyStatus={verifyStatus} />)}
      {role === 'expertDeveloper' && (<ButtonsGroupExpertDeveloper segmentId={segmentId} statusId={statusId} experts={experts} users={users} verifyStatus={verifyStatus} />)}
      {role === 'expertReviewer' && (<ButtonsGroupExpertDeveloper segmentId={segmentId} statusId={statusId} experts={experts} users={users} verifyStatus={verifyStatus} />)}
      {role === 'methodist' && (<ButtonsGroupMethodist segmentId={segmentId} statusId={statusId} experts={experts} users={users} />)}
    </>
  )
})

export default withDataProvider(ToolbarProvider)
